<script>
	import { slugify } from "cando-util";

	export let value;
	export let label = "textarea component";
	export let key = "";
	export let tabIndex = 0;
	export let disabled = false;
	export let handleInputChange = () => {};
	export let handleKeydown = () => {};
	export let handleChange = () => {};
	export let additionalClass = "";
	// export let widthClass = 'w-[500px] md:w-[300px] lg:w-[600px]';
	export let widthClass = "w-full";
	export let placeholder = "";
	export let autocomplete = "off";
	export let ariaAutocomplete = "none";
	export let readonly = false;
	export let keepTab = true;
	export let itemId = "";

	// this if from the safelist.  check and make sure the preprocessor picks these up and lets us use in the build.
	const heights = [
		"h-[2rem]",
		"h-[4rem]",
		"h-[6rem]",
		"h-[8rem]",
		"h-[10rem]",
		"h-[12rem]",
		"h-[14rem]",
		"h-[16rem]",
		"h-[18rem]",
		"h-[20rem]",
		"h-[22rem]",
		"h-[24rem]",
	];

	$: heightClass = `h-[${Math.min(
		24, // max height in rem
		((value || "")
			.toString()
			.split("\n")
			.map((e) => Math.ceil((e.length + 1) / 100))
			.reduce((a, v) => a + v, 0) +
			1) *
			2,
	).toString()}rem]`;

	const ignoreTabKeyDown = (event) => {
		if (event.key === "Tab" && keepTab) {
			event.preventDefault();

			const textarea = event.target;
			const start = textarea.selectionStart;
			const end = textarea.selectionEnd;

			// Insert tab character
			textarea.value =
				textarea.value.substring(0, start) +
				"\t" +
				textarea.value.substring(end);

			// Move cursor to correct position
			textarea.selectionStart = textarea.selectionEnd = start + 1;
		}
		handleKeydown(event);
	};
</script>

<textarea
	id={`${slugify(label)}-input`}
	name={`${label}`}
	{key}
	tabindex={tabIndex}
	bind:value
	on:input={handleInputChange}
	on:keydown={ignoreTabKeyDown}
	on:change={handleChange}
	class={`${widthClass} p-2 sm:p-4 textarea ${additionalClass} ${heightClass}`}
	{autocomplete}
	aria-autocomplete={ariaAutocomplete}
	{disabled}
	{readonly}
	{placeholder}
	{itemId}
></textarea>
